import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SpesielleBegrensningerMaksVogntogLengde } from "../../RouteDescription/SpesielleBegrensningerMaksVogntogLengde";
import { RoadFeaturesWithBruksklasse } from "../../../services/RuteplanAPI";

export default function SpesielleBegrensningerMaksVogntogLengdeListItem(props: IRoadFeatureListItemProps) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };

  const roadFeatureResponse = props.roadFeatureResponse as RoadFeaturesWithBruksklasse;

  if(roadFeatureResponse.spesielleBegrensningerMaksVogntogLengde?.length === 0 ||
    roadFeatureResponse.spesielleBegrensningerMaksVogntogLengde === undefined) {
    return(<></>);
  }
  
  return(
    <>
    { roadFeatureResponse && roadFeatureResponse.spesielleBegrensningerMaksVogntogLengde && roadFeatureResponse.spesielleBegrensningerMaksVogntogLengde.length > 0 && (
      <>
        <ListItemButton
        onClick={onClick}>
          <ListItemText primary={`Begrensning maks vogntoglengde (${roadFeatureResponse.spesielleBegrensningerMaksVogntogLengde?.length})`}/> 
          {open ? <ExpandLess /> : <ExpandMore />} 
        </ListItemButton>
        <Collapse
        in={open}
        timeout="auto" 
        unmountOnExit
        >
          <SpesielleBegrensningerMaksVogntogLengde roadFeatures={roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
        </Collapse>
        <Divider />
      </>
    )}
    
    </>
  )
}